<div class="p-accordion-custom">
  <div class="alert alert-info py-2 w-100 me-2">
    <i class="bi bi-info-circle me-1"></i> You can drag files using &nbsp;
    <b><i class="bi bi-arrows-expand fw-600"></i></b> &nbsp; icon to reorder the documents
  </div>
  <p-accordion>
    @for (project of projectTemplates(); track project.projectId) {
      <p-accordion-panel value="{{ $index }}">
        <p-accordion-header>
          <h3 class="mb-0">
            {{ project.projectName }} ({{ project.projectCode }})
            @if (project.totalCount > 0) {
              <span class="border fw-400 fs-14 px-2 py-1 rounded-2 ms-2">{{ project.totalCount }} documents</span>
            }
          </h3>
        </p-accordion-header>
        <p-accordion-content>
          <div class="d-flex">
            <button (click)="openAddProductModal(project.projectId)" class="btn btn-primary btn-h40 ms-auto">
              <i class="bi bi-upload me-1"></i>Upload
            </button>
          </div>

          @if (project.typeSections.length === 0) {
            <p class="text-muted text-center py-3">No documents uploaded for this project yet.</p>
          }

          @for (section of project.typeSections; track section.type) {
            <div class="mb-4">
              <div class="d-flex align-items-center gap-2 mb-2">
                <h5 class="mb-0 fw-600">{{ section.label }}</h5>
                <span class="badge bg-secondary rounded-pill">{{ section.templates.length }}</span>
              </div>

              <div class="table-outer table-theme">
                <div class="table-responsive">
                  <p-table
                    [value]="section.templates"
                    (onRowReorder)="onReorder($event, project.projectId, section.type)"
                  >
                    <ng-template #header>
                      <tr>
                        @if (section.label === 'APS') {
                          <th [width]="10"></th>
                          <th [width]="10" class="text-center">Sq. No</th>
                        }
                        <th>File Name</th>
                        <th [width]="50">Actions</th>
                        <th [width]="50"></th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-template let-index="rowIndex">
                      <tr [pReorderableRow]="index">
                        @if (section.label === 'APS') {
                          <td><i class="bi bi-arrows-expand" pReorderableRowHandle></i></td>
                          <td>
                            <div class="text-center">{{ template.sequence }}</div>
                          </td>
                        }
                        <td><i class="bi bi-file-earmark me-1"></i>{{ template.name }}</td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <a role="button" class="text-decoration-none fs-14" (click)="openPreviewModal(template)">
                              <i class="bi bi-eye me-1"></i>View
                            </a>
                            <span class="text-grayborder">|</span>
                            <a class="text-decoration-none fs-14 cursor-pointer" (click)="downloadDocument(template)">
                              <i class="bi bi-download me-1"></i>Download
                            </a>
                          </div>
                        </td>
                        <td>
                          <div ngbDropdown container="body" class="ms-auto">
                            <svg-icon [name]="'menu-dots'" class="svg-24" ngbDropdownToggle></svg-icon>
                            <div ngbDropdownMenu placement="bottom-start">
                              <button (click)="openReplaceModal(template.id)" class="dropdown-item">Replace</button>
                              <button
                                (click)="deleteDocumentConfirmation($event, template.id)"
                                class="dropdown-item text-danger"
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          }
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</div>

<p-confirmdialog />

<router-outlet />
